// Copied from https://overreacted.io/making-setinterval-declarative-with-react-hooks/

import React, {useEffect, useRef} from 'react';

type Callback = () => void;

export default function useInterval(callback: Callback, delay: number) {
    const savedCallback = useRef<Callback>();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    });

    // Set up the interval.
    useEffect(() => {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
